<div *ngIf="currentLength && maxLength" class="form-text text-info" i18n>
  Pozostało {{ getRemainingSigns() }} z {{ maxLength }} znaków.
</div>
